import clsx from 'clsx';

type Props = React.HTMLAttributes<HTMLParagraphElement>;
export function ButtonGroupText({
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <p
      {...props}
      className={clsx(
        'relative inline-flex items-center justify-center bg-slate1 px-3 py-2 text-xs/3 font-semibold text-slate11 ring-1 ring-inset ring-slate6',
        className
      )}
    >
      {props.children}
    </p>
  );
}

ButtonGroupText.displayName = 'ButtonGroupText';
